import { Button, Modal, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useNavigate } from 'react-router-dom';
import UserApi from '../../../Api/UserApi';
import {
  fetchUserLevels,
  fetchExistingEmails,
} from '../../../Actions/CommonFields';
import { useAppDispatch, useAppSelector } from '../../../Reducers/store';
import { AssetTypeEnum } from '../../../Models/AssetType';
import { Asset } from '../../../Models/Asset';
import DriverInspectionCheckModal from './DriverInspectionCheckModal';
import { SopformTypeEnum } from '../../../Models/Sopform';
import { UserClockIn } from '../../../Models/UserClockIn';
import { convertTZ } from '../../../Utils';
import { format } from 'date-fns';
import { FaCheck, FaCross, FaTimes, FaTrailer, FaTruck } from 'react-icons/fa';
import DriverSelectAsset from './DriverSelectAsset';
import { Inspection, InspectionTypeEnum } from '../../../Models/Inspection';
import InspectionApi from '../../../Api/InspectionApi';
import { InspectionAsset } from '../../../Models/InspectionAsset';
import AssetLoadInModal from '../../Asset/AssetLoadInModal';
import AssetApi from '../../../Api/AssetApi';
import { AssetQuantity } from '../../../Models/AssetQuantity';
import EditReimbursementModal from '../../Reimbursement/EditReimbursementModal';

export default function DriverClockInOut({
  show,
  setShow,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userLevels, existingEmails } = useAppSelector(
    (state) => state.commonFields
  );
  const { userModel } = useAppSelector((state) => state.user);
  const [userClockIn, setuserClockIn] = useState<UserClockIn | null>(null);
  const [showSOPForm, setshowSOPForm] = useState<boolean>(false);
  const [inspectionAssetId, setinspectionAssetId] = useState<number>(0);
  const [latestInspectionTruck, setlatestInspectionTruck] =
    useState<InspectionAsset | null>(null);
  const [latestInspectionTrailer, setlatestInspectionTrailer] =
    useState<InspectionAsset | null>(null);
  const [inspectionType, setinspectionType] = useState<number>(0);
  const [showSelectTruck, setshowSelectTruck] = useState<boolean>(false);
  const [selectedTruck, setselectedTruck] = useState<Asset | null>(null);
  const [showSelectTrailer, setshowSelectTrailer] = useState<boolean>(false);
  const [selectedTrailer, setselectedTrailer] = useState<Asset | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [latestInspection, setlatestInspection] = useState<Inspection | null>(
    null
  );
  const [showLoadInForm, setshowLoadInForm] = useState<boolean>(false);
  const [showReimbursementInfo, setshowReimbursementInfo] =
    useState<boolean>(false);
  const [loadinAssetId, setloadinAssetId] = useState<number>(0);

  const [formData, setFormData] = useState<Inspection>({
    id: 0,
    userId: userModel?.id ?? 0,
    typeId: InspectionTypeEnum.Pre,
    mileage: null,
    dateCreated: null,

    inspectionAssets: [],
    user: null,
  });

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      userId: userModel?.id ?? 0,
      typeId: InspectionTypeEnum.Pre,
      mileage: null,
      dateCreated: null,

      inspectionAssets: [],
    };
    setFormData(values as Inspection);
    setlatestInspection(null);
    setlatestInspectionTruck(null);
    setlatestInspectionTrailer(null);
    setselectedTruck(null);
    setselectedTrailer(null);
  };
  const getReferences = async () => {
    if (!userLevels.length || !existingEmails.length) {
      await Promise.all([
        dispatch(fetchUserLevels()),
        dispatch(fetchExistingEmails()),
      ]);
    }
  };

  const getLatestUserClockIn = async () => {
    if (userModel?.id) {
      return UserApi.getLatestUserClockIn(userModel?.id)
        .then((res) => {
          setuserClockIn(res.data);
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    }
  };

  const getUserLatestInspection = async () => {
    if (userModel?.id) {
      return InspectionApi.getUserLatestInspection(userModel?.id)
        .then((res) => {
          if (res.data) {
            const latestTruck =
              res.data.inspectionAssets.find(
                (x) => x.asset?.typeId == AssetTypeEnum.Truck
              ) ?? null;
            const latestTrailer =
              res.data.inspectionAssets.find(
                (x) => x.asset?.typeId == AssetTypeEnum.Trailer
              ) ?? null;

            if (
              res.data.typeId === InspectionTypeEnum.Post &&
              res.data.mileage &&
              res.data.mileage > 0 &&
              latestTruck?.sopformId &&
              latestTruck?.sopformId > 0 &&
              latestTrailer?.sopformId &&
              latestTrailer?.sopformId > 0
            ) {
              handleResetFormValues();
            } else {
              setFormData(res.data);
              setlatestInspection(res.data);
              setlatestInspectionTruck(latestTruck);
              setlatestInspectionTrailer(latestTrailer);
            }
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    }
  };

  const userClockInOut = async () => {
    if (
      latestInspection &&
      latestInspection?.typeId === InspectionTypeEnum.Pre
    ) {
      toast.error('You must complete the Post-Inspection before Clocking Out');
    } else {
      if (userModel?.id) {
        return UserApi.userClockInOut(userModel?.id)
          .then((res) => {
            if (res.data.success) {
              toast.success(res.data.message);
              getLatestUserClockIn();
            } else {
              toast.error('Error clocking in');
            }
          })
          .catch((err) => {
            toast.error('Error: ' + err);
            setIsLoading(false);
            setButtonDisabled(false);
          });
      }
    }
  };

  // const getAssetQuantitiesByAssetId = async () => {
  //   if (latestInspectionTrailer && latestInspectionTrailer.assetId) {
  //     return AssetApi.getAssetQuantitiesByAssetId(
  //       latestInspectionTrailer.assetId
  //     )
  //       .then((res) => {
  //         setassetQuantityList(res.data);
  //       })
  //       .catch((err) => {
  //         toast.error('Error: ' + err);
  //         setIsLoading(false);
  //         setButtonDisabled(false);
  //       });
  //   }
  // };

  useEffect(() => {
    if (show === true) {
      getReferences();
      getLatestUserClockIn();
      getUserLatestInspection();
      // getAssetQuantitiesByAssetId();
    }
  }, [show]);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.userId! > 0) {
      setButtonDisabled(true);
      setIsLoading(true);
      let inspectionId = 0;
      await InspectionApi.addUpdateInspection(formData)
        .then((res) => {
          inspectionId = +res.data.affectedEntityIdentifier;
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
      if (inspectionId > 0) {
        const truckForm = {
          id: 0,
          inspectionId: inspectionId,
          assetId: selectedTruck?.id,
          sopformId: null,

          asset: null,
          sopform: null,
        } as InspectionAsset;
        await InspectionApi.addUpdateInspectionAsset(truckForm)
          .then((res) => {
            //truck added
          })
          .catch((err) => {
            toast.error('Error: ' + err);
          });
        const trailerForm = {
          id: 0,
          inspectionId: inspectionId,
          assetId: selectedTrailer?.id,
          sopformId: null,

          asset: null,
          sopform: null,
        } as InspectionAsset;
        await InspectionApi.addUpdateInspectionAsset(trailerForm)
          .then((res) => {
            //truck added
          })
          .catch((err) => {
            toast.error('Error: ' + err);
          });
      }
      getUserLatestInspection();
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  const onSubmitPost = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.userId! > 0) {
      // if(latestInspectionTruck === null || latestInspectionTrailer === null){
      //   toast.error('You must complete Post-Inspection forms')
      // }
      setButtonDisabled(true);
      setIsLoading(true);
      await InspectionApi.addUpdateInspection(formData)
        .then((res) => {
          getUserLatestInspection();
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  function onCloseModal() {
    setShow(false);
  }

  function openSopform(inspectionAssetId: number, inspectionType: number) {
    setinspectionAssetId(inspectionAssetId);
    setinspectionType(inspectionType);
    setshowSOPForm(true);
  }

  const startPostInspection = async () => {
    if (latestInspection?.id) {
      setButtonDisabled(true);
      setIsLoading(true);
      return InspectionApi.createPostInspection(latestInspection?.id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            setIsLoading(false);
            setButtonDisabled(false);
            getUserLatestInspection();
          } else {
            toast.error('Error Creating Post Inspection');
            setIsLoading(false);
            setButtonDisabled(false);
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    }
  };

  function disableClockOut() {
    if (latestInspection === null) {
      return false;
    }
    return true;
  }

  function openLoadIn(assetId: number) {
    setloadinAssetId(assetId);
    setshowLoadInForm(true);
  }

  return (
    <>
      <Modal show={show} size='xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='w-full'>
                <div className='mx-1 flex items-end justify-center'>
                  <div className='flex flex-1 justify-center'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      Driver Options
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className='container mx-auto p-2'>
                  <div className='md:flex no-wrap md:-mx-2 '>
                    <div className='w-full'>
                      <div className='bg-white'>
                        <div className='text-gray-500'>
                          <div className='flex justify-between text-xl pb-5'>
                            {!userClockIn && (
                              <div className='flex'>
                                <Button
                                  disabled={buttonDisabled}
                                  type='button'
                                  className='buttonMainAlt'
                                  onClick={userClockInOut}
                                >
                                  Clock In
                                </Button>
                              </div>
                            )}
                            {userClockIn && (
                              <div className='flex'>
                                <Button
                                  //disabled={disableClockOut()}
                                  type='button'
                                  className='buttonCancel'
                                  onClick={userClockInOut}
                                >
                                  Clock Out
                                </Button>
                              </div>
                            )}
                            {userClockIn && (
                              <div className='flex items-center text-sm'>
                                Time In:{' '}
                                {userClockIn.timeIn
                                  ? format(new Date(userClockIn.timeIn), 'MM-dd-yyyy hh:mm a')
                                  : ''}
                              </div>
                            )}
                            <div className='flex'>
                              <Button
                                disabled={buttonDisabled}
                                type='button'
                                className='buttonMain'
                                onClick={() => setshowReimbursementInfo(true)}
                              >
                                Reimbursement
                              </Button>
                            </div>
                          </div>
                          <div className=''>
                            {userClockIn &&
                              latestInspection &&
                              latestInspectionTruck &&
                              latestInspectionTrailer && (
                                <div className='grid grid-cols-[30%_70%] text-xl pb-5'>
                                  <div className='flex'>
                                    <Button
                                      type='button'
                                      className='buttonMain'
                                      onClick={() =>
                                        openLoadIn(
                                          latestInspectionTrailer.assetId ?? 0
                                        )
                                      }
                                    >
                                      Load In
                                    </Button>
                                  </div>
                                  <div className='flex items-center text-sm'>
                                    <div className='text-lg font-bold'>
                                      {latestInspectionTrailer.asset?.name}:{' '}
                                    </div>
                                    <div className='pl-4'>
                                      {latestInspectionTrailer.asset?.assetQuantities.map(
                                        (q) => (
                                          <div key={q.id}>
                                            {q.inventoryType?.name}:{' '}
                                            {q.quantity}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                          {userClockIn &&
                            (!latestInspection ||
                              !latestInspectionTruck ||
                              !latestInspectionTrailer) && (
                              <div>
                                <form
                                  id='preInspectionForm'
                                  onSubmit={onSubmit}
                                >
                                  <div className='grid grid-cols-2 text-black'>
                                    <div className='m-3'>
                                      {!selectedTruck && (
                                        <div
                                          className='grid grid-cols-1 justify-items-center border rounded-md py-2 cursor-pointer hover:bg-gray-300'
                                          onClick={() =>
                                            setshowSelectTruck(true)
                                          }
                                        >
                                          <span>Assign Truck</span>
                                          <div>
                                            <FaTruck size={30} />
                                          </div>
                                        </div>
                                      )}
                                      {selectedTruck && (
                                        <div>
                                          <div
                                            className='cursor-pointer'
                                            onClick={() =>
                                              setshowSelectTruck(true)
                                            }
                                          >
                                            {selectedTruck.name}
                                            {' - '}
                                            {selectedTruck.number}
                                          </div>
                                          <div>
                                            <TextInput
                                              id='mileage'
                                              name='mileage'
                                              type='text'
                                              placeholder='Mileage'
                                              onChange={handleChangeInput}
                                              value={formData.mileage ?? ''}
                                              sizing='md'
                                              required
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className='m-3'>
                                      {!selectedTrailer && (
                                        <div
                                          className='grid grid-cols-1 justify-items-center border rounded-md py-2 cursor-pointer hover:bg-gray-300'
                                          onClick={() =>
                                            setshowSelectTrailer(true)
                                          }
                                        >
                                          <span>Assign Trailer</span>
                                          <div>
                                            <FaTrailer size={30} />
                                          </div>
                                        </div>
                                      )}
                                      {selectedTrailer && (
                                        <div>
                                          <div
                                            className='cursor-pointer'
                                            onClick={() =>
                                              setshowSelectTrailer(true)
                                            }
                                          >
                                            {selectedTrailer.name}
                                            {' - '}
                                            {selectedTrailer.number}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div></div>
                                    <div className='flex justify-end'>
                                      {selectedTruck && selectedTrailer && (
                                        <Button
                                          disabled={buttonDisabled}
                                          type='submit'
                                          className='buttonMain'
                                          form='preInspectionForm'
                                        >
                                          Save
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </div>
                            )}
                          {latestInspection &&
                            latestInspectionTruck &&
                            latestInspectionTrailer && (
                              <div>
                                <form
                                  id='postInspectionForm'
                                  onSubmit={onSubmitPost}
                                >
                                  <div className='flex items-center'>
                                    <div>
                                      {latestInspection.typeId! ===
                                      InspectionTypeEnum.Pre
                                        ? 'Starting'
                                        : 'Ending'}{' '}
                                      Mileage:
                                    </div>
                                    <div className='w-1/2 ml-2'>
                                      <TextInput
                                        id='mileage'
                                        name='mileage'
                                        type='text'
                                        placeholder='Mileage'
                                        onChange={handleChangeInput}
                                        value={formData.mileage ?? ''}
                                        sizing='md'
                                        required
                                        disabled={
                                          latestInspection.typeId! ===
                                          InspectionTypeEnum.Pre
                                        }
                                      />
                                    </div>
                                  </div>
                                </form>
                                <div className='grid grid-cols-2 text-black'>
                                  <div className='m-3'>
                                    {!latestInspectionTruck.sopformId && (
                                      <div
                                        className='grid grid-cols-1 text-center border rounded-md py-2 cursor-pointer bg-yellow-100 hover:bg-gray-300'
                                        onClick={() =>
                                          openSopform(
                                            latestInspectionTruck.id,
                                            latestInspection.typeId!
                                          )
                                        }
                                      >
                                        <div className='flex justify-center items-center gap-4'>
                                          <span>
                                            Truck{' '}
                                            {latestInspection.typeId! ===
                                            InspectionTypeEnum.Pre
                                              ? 'Pre'
                                              : 'Post'}
                                            -Inspection
                                          </span>
                                          <FaTimes />
                                        </div>
                                      </div>
                                    )}
                                    {latestInspectionTruck.sopformId && (
                                      <div className='grid grid-cols-1 text-center text-white border rounded-md py-2 bg-green-500'>
                                        <div className='flex justify-center items-center gap-4'>
                                          <span>
                                            Truck{' '}
                                            {latestInspection.typeId! ===
                                            InspectionTypeEnum.Pre
                                              ? 'Pre'
                                              : 'Post'}
                                            -Inspection
                                          </span>
                                          <FaCheck />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className='m-3'>
                                    {!latestInspectionTrailer.sopformId && (
                                      <div
                                        className='grid grid-cols-1 text-center border rounded-md py-2 cursor-pointer bg-yellow-100 hover:bg-gray-300'
                                        onClick={() =>
                                          openSopform(
                                            latestInspectionTrailer.id,
                                            latestInspection.typeId!
                                          )
                                        }
                                      >
                                        <div className='flex justify-center items-center gap-4'>
                                          <span>
                                            Trailer{' '}
                                            {latestInspection.typeId! ===
                                            InspectionTypeEnum.Pre
                                              ? 'Pre'
                                              : 'Post'}
                                            -Inspection
                                          </span>
                                          <FaTimes />
                                        </div>
                                      </div>
                                    )}
                                    {latestInspectionTrailer.sopformId && (
                                      <div className='grid grid-cols-1 text-center text-white border rounded-md py-2 bg-green-500'>
                                        <div className='flex justify-center items-center gap-4'>
                                          <span>
                                            Trailer{' '}
                                            {latestInspection.typeId! ===
                                            InspectionTypeEnum.Pre
                                              ? 'Pre'
                                              : 'Post'}
                                            -Inspection
                                          </span>
                                          <FaCheck />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div></div>
                                  {latestInspection.typeId ===
                                    InspectionTypeEnum.Pre &&
                                    latestInspectionTruck.sopformId &&
                                    latestInspectionTruck.sopformId > 0 &&
                                    latestInspectionTrailer.sopformId &&
                                    latestInspectionTrailer.sopformId > 0 && (
                                      <div className='mx-3 flex justify-end'>
                                        <Button
                                          disabled={buttonDisabled}
                                          type='button'
                                          className='buttonMain'
                                          onClick={() => startPostInspection()}
                                        >
                                          Start Post-Inspection
                                        </Button>
                                      </div>
                                    )}
                                  {latestInspection.typeId ===
                                    InspectionTypeEnum.Post && (
                                    <div className='mx-3 flex justify-end'>
                                      <Button
                                        disabled={buttonDisabled}
                                        type='submit'
                                        className='buttonMain'
                                        form='postInspectionForm'
                                      >
                                        Save
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <DriverInspectionCheckModal
        show={showSOPForm}
        setShow={setshowSOPForm}
        inspectionAssetId={inspectionAssetId}
        inspectionType={inspectionType}
        getUserLatestInspection={getUserLatestInspection}
      />
      <AssetLoadInModal
        show={showLoadInForm}
        setShow={setshowLoadInForm}
        assetId={loadinAssetId}
        getUserLatestInspection={getUserLatestInspection}
      />
      <DriverSelectAsset
        show={showSelectTruck}
        setShow={setshowSelectTruck}
        assetType={AssetTypeEnum.Truck}
        setselectedAsset={setselectedTruck}
      />
      <DriverSelectAsset
        show={showSelectTrailer}
        setShow={setshowSelectTrailer}
        assetType={AssetTypeEnum.Trailer}
        setselectedAsset={setselectedTrailer}
      />
      <EditReimbursementModal
        show={showReimbursementInfo}
        setShow={setshowReimbursementInfo}
        selectedReimbursement={null}
        setselectedReimbursement={null}
        getReimbursementList={null}
      />
    </>
  );
}
